import { Data, Layout } from '@pcmp/react-coworker-components';
import { useTranslation } from 'react-i18next';
import { Trans } from 'react-i18next';
import ListView, { ListViewItem } from '@ingka/list-view';
import { Faq } from '@/components/page-widgets/home/faq';

const { Container } = Layout;
const { Card } = Data;

function IndexPage() {
  const { t } = useTranslation();

  return (
    <div className="pb-[56px]">
      <Container className="pt-[52px] pb-[100px] ">
        <h1 className="text-4xl font-bold leading-[47.99px]">
          {t('page.home.title')}
        </h1>

        <p className="mt-4 text-skapa-text-3 leading-relaxed">
          {t('page.home.description')}
        </p>

        <div className="flex flex-col md:flex-row items-start mt-12 gap-6">
          <Card className="p-8 w-full md:max-w-[533px]">
            <div className="p-[12px] self-stretch">
              <Faq />
            </div>
          </Card>

          <div className="flex-grow">
            <Card>
              <div className="p-[12px] self-stretch">
                <h2 className="text-2xl font-bold leading-[34.80px]">
                  {t('page.home.stats.title')}
                </h2>

                <p className="mt-6 leading-relaxed">
                  {t('page.home.stats.description1')}
                </p>

                <p className="mt-6 leading-relaxed">
                  <Trans> {t('page.home.stats.description2')}</Trans>
                </p>

                <p className="mt-6 leading-relaxed">
                  <Trans>{t('page.home.stats.description3')}</Trans>
                </p>

                <ListView className="mt-6" id="report">
                  <ListViewItem
                    size="medium"
                    emphasised
                    image=""
                    title={t('page.home.stats.statisticsReport')}
                    control="link"
                    controlIcon="linkOut"
                    href="https://lookerstudio.google.com/reporting/8d567bd5-0567-4f0c-ba3c-16b4535df56d"
                    newWindow="blank"
                  />
                  <ListViewItem
                    onClick={() => {}}
                    size="medium"
                    emphasised
                    image=""
                    title={t('page.home.stats.overviewReport')}
                    control="link"
                    controlIcon="linkOut"
                    href="https://lookerstudio.google.com/reporting/806bf06b-f51d-4052-94aa-2f7ba57eb80c"
                    newWindow="blank"
                  />
                  <ListViewItem
                    size="medium"
                    emphasised
                    image=""
                    title={t('page.home.stats.freeTextReport')}
                    control="link"
                    controlIcon="linkOut"
                    href="https://lookerstudio.google.com/reporting/23fe6b3b-1ea4-4f09-988b-11edd4319f39"
                    newWindow="blank"
                  />
                </ListView>
              </div>
            </Card>
            <Card className="mt-4">
              <div className="p-[12px] self-stretch">
                <h2 className="text-2xl font-bold leading-[34.80px]">
                  {t('page.home.trainingPdf.title')}
                </h2>
                <p className="mt-6 leading-relaxed">
                  {t('page.home.trainingPdf.description')}
                </p>
                <ListView className="mt-6" id="report">
                  <ListViewItem
                    onClick={() => {}}
                    size="medium"
                    emphasised
                    image=""
                    title="QR Training.pdf"
                    control="link"
                    controlIcon="linkOut"
                    href="https://jira.digital.ingka.com/secure/attachment/1297975/1297975_QR+Training.pdf"
                    newWindow="blank"
                  />
                </ListView>
              </div>
            </Card>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default IndexPage;
